<mat-select class="mat-select-grow" panelClass="indent-5" #select (ngModelChange)="modelChange($event)" [(ngModel)]="selectedOption" (closed)="emitSelection()">
  @for (option of options; track $index) {
    <mat-option [value]="option" (click)="emitSelection()">{{
      option
    }}</mat-option>
  }
</mat-select>
